import React from 'react';

import {
	type BaseConversationAction,
	type ConversationAction,
	HandleActionType,
} from '../../types';

const PLACEHOLDER_ACTION_ID_PREFIX = 'dynamic-placeholder-';

// used for creating placeholder actions that represent 'loading' dynamic convo starters
export const createPlaceholderAction = (
	index: number,
	handleType?: HandleActionType,
): BaseConversationAction => ({
	id: `${PLACEHOLDER_ACTION_ID_PREFIX}${index}`, // id to identify placeholder actions
	title: '',
	icon: () => <></>,
	handleType: handleType ?? HandleActionType.Chat,
});

// used for identifying placeholder actions that represent 'loading' dynamic convo starters
export const isPlaceholderAction = (action: ConversationAction): boolean => {
	return action.id.startsWith(PLACEHOLDER_ACTION_ID_PREFIX);
};
